var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 40",
    style: {
      enableBackground: "new 0 0 210 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6333F;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "16.3,1.1 10.1,12.9 3.8,1.1 0,1.1 8.7,15.5 8.7,25.7 10.1,25.7 11.4,25.7 11.4,15.5 20.1,1.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.3,22.9 26.3,14.9 36.7,14.9 36.7,13.4 36.7,11.9 26.3,11.9 26.3,3.9 37.4,3.9 38.7,1.1 23.3,1.1  23.3,13.4 23.3,25.7 38.7,25.7 37.4,22.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "177.5,14.9 187.9,14.9 187.9,13.4 187.9,11.9 177.5,11.9 177.5,3.9 188.6,3.9 190,1.1 174.6,1.1  174.6,13.4 174.6,25.7 177.5,25.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "104.4,20 93.5,1.1 93.5,25.5 96.4,25.5 96.4,12.3 104.4,25.5 112.4,12.3 112.4,25.5 115.3,25.5  115.3,1.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.2,4.5c0,0-2-4.1-7.8-4.1s-7.7,4.3-7.7,6.9s0.5,4.7,5.2,6.1s7.7,1.4,8.3,4.2s-1.7,5.1-5.2,5.1 c-2.5,0-4.8-1-6.5-2.8c-0.9,0.3-2.5,1.1-2.5,1.1c2,3,5.4,4.7,9,4.7c6.3,0,8.2-4.8,8.2-7.4s-0.9-5.5-6.4-6.6s-7.3-2.3-7.3-4.6 s2.1-4,5.1-4s5.5,2.6,5.5,2.6L141.2,4.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "201.3,1.1 192.6,1.1 194.1,4.1 199.9,4.1 199.9,25.7 201.3,25.7 202.7,25.7 202.7,4.1 208.5,4.1  210,1.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.3,1.1c-5.6,0-12.6,3.6-12.6,12.3s7,12.3,12.6,12.3s12.6-3.6,12.6-12.3S82.9,1.1,77.3,1.1z M77.3,23.4 c-3.5,0-9.6-2-9.6-10s6.1-10,9.6-10s9.6,2.1,9.6,10S80.8,23.4,77.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.3,1.1c-5.6,0-12.6,3.6-12.6,12.3s7,12.3,12.6,12.3s12.6-3.6,12.6-12.3S164.9,1.1,159.3,1.1z M159.3,23.4 c-3.5,0-9.6-2-9.6-10s6.1-10,9.6-10s9.6,2.1,9.6,10S162.8,23.4,159.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,20c-1.9,2.1-4.6,3.3-7.4,3.3c-3.5,0-9.6-2-9.6-10s6.2-10,9.6-10c2.8,0,5.5,1.2,7.4,3.3l1.4-2.3 C60,2.1,56.8,1,53.6,1C48,1,41,4.6,41,13.3s7,12.3,12.6,12.3c3.2,0,6.4-1.1,8.8-3.3L61,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,39.7L9.8,33h0.7l2.6,6.7h-0.7l-0.8-2.1h-3l-0.8,2.1H7.2z M8.9,37h2.6l-1.3-3.5L8.9,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,39.7V33h0.6v6.1h3.6v0.5L18,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.1,39.7V33h0.6v6.1h3.6v0.5L27.1,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,39.7V33h0.6v6.1h3.6v0.5L42.7,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.1,39.7V33h0.6v6.7H52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.8,33h0.7l2,5.9l2-5.9h0.7l-2.3,6.7h-0.7L57.8,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.2,39.7V33h0.6v6.7H68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.1,33.8L75.1,33.8v5.8h-0.6V33h0.7l3.9,5.8l0,0V33h0.6v6.7H79L75.1,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,36.7v-0.5h2.9v3.5h-0.5v-1.2c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.3,0.3-0.5,0.4 c-0.2,0.1-0.4,0.2-0.7,0.3s-0.6,0.1-0.9,0.1c-0.4,0-0.8-0.1-1.2-0.2c-0.4-0.1-0.7-0.4-0.9-0.7c-0.3-0.3-0.5-0.7-0.6-1.1 c-0.2-0.5-0.2-1-0.2-1.6c0-0.5,0.1-0.9,0.2-1.4c0.1-0.4,0.3-0.8,0.6-1.1s0.6-0.6,1-0.7c0.4-0.2,0.9-0.3,1.3-0.3c0.3,0,0.7,0,1,0.1 s0.6,0.2,0.8,0.4s0.5,0.4,0.6,0.7c0.2,0.3,0.3,0.6,0.4,0.9h-0.6c-0.1-0.2-0.2-0.5-0.3-0.7s-0.3-0.4-0.5-0.5s-0.4-0.2-0.6-0.3 c-0.2-0.1-0.5-0.1-0.7-0.1c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.2-0.6,0.4-0.8,0.7s-0.4,0.6-0.4,1c-0.1,0.4-0.1,0.9-0.1,1.3 c0,0.4,0.1,0.7,0.2,1.1c0.1,0.3,0.3,0.6,0.5,0.9c0.2,0.3,0.5,0.5,0.8,0.6s0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0.1-0.5,0.1-0.7L88,36.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.1,39.7V33h0.6v6.7H103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110,33.8L110,33.8v5.8h-0.6V33h0.7l3.9,5.8l0,0V33h0.6v6.7h-0.7L110,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,39.7V33h0.6v2.9h3.9V33h0.6v6.7h-0.6v-3.3h-3.9v3.3H126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.6,39.7l2.6-6.7h0.7l2.6,6.7h-0.6l-0.8-2.1h-3l-0.8,2.1H136.6z M138.2,37h2.6l-1.3-3.5L138.2,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148,36.6v3h-0.6V33h2.6c0.6,0,1.2,0.1,1.7,0.4c0.4,0.3,0.6,0.8,0.6,1.3c0,0.4-0.1,0.7-0.3,1 s-0.5,0.5-0.8,0.6c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.3,0.1,0.5s0,0.4,0,0.5c0,0.2,0,0.4,0,0.6 c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.1v0.1h-0.7c-0.1-0.1-0.1-0.3-0.1-0.5s0-0.4-0.1-0.6s0-0.4,0-0.6 c0-0.2,0-0.3-0.1-0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1H150H148z M150,36.1 c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6 c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.3-0.2-0.5-0.2s-0.4,0-0.6,0h-2v2.6L150,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.4,39.7V33h1l2.2,5.9l0,0l2.1-5.9h1v6.7h-0.6v-6l0,0l-2.2,6h-0.6l-2.2-6l0,0v6H157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.9,36.3c0-0.5,0.1-0.9,0.2-1.4c0.1-0.4,0.3-0.8,0.6-1.1s0.6-0.6,1-0.8s0.9-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.4,0.3c0.4,0.2,0.7,0.4,1,0.8c0.3,0.4,0.4,0.7,0.5,1.2c0.1,0.4,0.2,0.9,0.2,1.4s-0.1,0.9-0.2,1.4 c-0.1,0.4-0.3,0.8-0.6,1.1s-0.6,0.6-1,0.8c-0.9,0.4-1.8,0.4-2.7,0c-0.4-0.2-0.7-0.4-1-0.8c-0.3-0.3-0.5-0.7-0.6-1.1 C168.9,37.3,168.9,36.8,168.9,36.3z M172,39.3c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.8-0.7s0.4-0.6,0.4-0.9 c0.1-0.4,0.1-0.7,0.1-1.1c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.3-0.3-0.7-0.5-0.9c-0.2-0.3-0.5-0.5-0.8-0.6s-0.7-0.2-1-0.2 c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.2-0.6,0.4-0.8,0.7s-0.4,0.6-0.4,1c-0.2,0.7-0.2,1.5,0,2.3c0.1,0.3,0.2,0.7,0.4,0.9 c0.2,0.3,0.5,0.5,0.8,0.7C171.3,39.3,171.6,39.3,172,39.3L172,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.9,33.8L180.9,33.8v5.8h-0.6V33h0.7l3.9,5.8l0,0V33h0.6v6.7h-0.7L180.9,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193,36.2l2-3.2h0.7l-2.4,3.8v2.9h-0.6v-2.9l-2.4-3.8h0.7L193,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201,35.1V33h0.7v2.1l-0.1,2.9h-0.4L201,35.1z M201,39.7v-0.8h0.7v0.8H201z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoType);
export default __webpack_public_path__ + "static/media/logo-type.68a15a7277196dc5df7d18d17143f0b9.svg";
export { ForwardRef as ReactComponent };